import { render, staticRenderFns } from "./InstanceInviteDialog.vue?vue&type=template&id=5c1b49d0&"
import script from "./InstanceInviteDialog.vue?vue&type=script&lang=js&"
export * from "./InstanceInviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports